import styled from 'styled-components';
import { rem } from 'polished';
import AvatarPerson from '../AvatarPerson';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';

const StyledHeaderDirectory = styled.div`
  display: none;
  ${mediaqueries.greaterThan('tabletLandscape')`
     display: table-header-group;
  `};
`;

const StyledHeaderItem = styled.div`
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.dark};
  display: table-cell;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  overflow: hidden;
  padding: ${rem('0px')} ${rem('10px')};
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const StyledTableWrapper = styled.div`
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: table;
    width: 100%;
  `};
`;

const StyledEmployerDirectory = styled.div`
  background-color: ${props => props.theme.colors.grayLightest};
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  display: block;
  padding: ${rem('17px')} ${rem('25px')};
  max-height: ${rem('74px')};
  overflow: hidden;
  position: relative;
  &:nth-child(1) {
    border-top: ${rem('2px')} solid ${props => props.theme.colors.grayDark};
  }

  ${props =>
    props.active &&
    `
    max-height: none;
  `};

  ${mediaqueries.greaterThan('tabletLandscape')`
    background-color: ${props => props.theme.colors.grayMoreLight};
    border-bottom-color: ${props => props.theme.colors.grayLighter};
    display: table-row-group;
    max-width: inherit;
    padding: ${rem('11px')};
    max-height: none;
    overflow: auto;
  `};
`;

const IconButton = styled(Icon)`
  fill: ${props =>
    props.active ? props.theme.colors.primary : props.theme.colors.dark};
  left: ${rem('7px')};
  margin-right: 1rem;
  position: absolute;
  top: ${rem('23px')};
  transform: rotate(90deg);
  transition: none;
  width: ${rem('15px')};
  height: ${rem('12px')};

  ${props =>
    props.active &&
    `
    transform: rotate(-90deg);
  `};
  ${mediaqueries.greaterThan('tabletLandscape')`
    display: none;
  `};
`;

const StyledPhoto = styled(AvatarPerson)`
  border: ${rem('2px')} solid ${props => props.theme.colors.grayDarkest};
  float: right;
  font-size: 100%;
  height: ${rem('45px')};
  margin-bottom: ${rem('8px')};
  width: ${rem('45px')};

  ${mediaqueries.greaterThan('tabletLandscape')`
    height: ${rem('40px')};
    margin: ${rem('0px')} 0 ${rem('0px')} ${rem('10px')};
    width: ${rem('40px')};
  `};
`;
const StyledNamesWraper = styled.div`
  margin-right: ${rem('20px')};
  width: 77%;

  ${mediaqueries.greaterThan('tabletLandscape')`
    display: table;
    width: 100%;
  `};
`;

const StyledEmployerName = styled.div`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('14px')};
  max-width: ${rem('120px')};
  ${mediaqueries.greaterThan('tabletLandscape')`
    border-bottom: ${rem('1px')} solid ${props =>
    props.theme.colors.grayLighter};
    display: table-cell;
    font-family: ${props => props.theme.fonts.book};
    margin-right: ${rem('20px')};
    overflow: hidden;
    padding: ${rem('15px')} ${rem('10px')};
    text-overflow: ellipsis;
    vertical-align: middle;
    white-space: nowrap;
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('120px')};
  `};
`;

const StyledEmployerLastName = styled(StyledEmployerName)`
  max-width: ${rem('186px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('186px')};
  `};
`;

const StyledEmployerAlias = styled(StyledEmployerName)`
  max-width: ${rem('186px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('186px')};
  `};
`;

const StyledEmployerTableCell = styled.div`
  display: block;
  font-family: ${props => props.theme.fonts.book};
  font-size: ${rem('14px')};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  ${mediaqueries.greaterThan('tabletLandscape')`
    border-bottom: 1px solid ${props => props.theme.colors.grayLighter};
    display: table-cell;
    margin-right: ${rem('20px')};
    padding: ${rem('10px')} ${rem('10px')};
    vertical-align: middle;
  `};
`;

const StyledEmployerTableCellProfile = styled(StyledEmployerTableCell)`
  max-width: ${rem('186px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('186px')};
  `};
`;

const StyledEmployerTableCellDepartment = styled(StyledEmployerTableCell)`
  max-width: ${rem('230px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('230px')};
  `};
`;

const StyledEmployerTableCellExtension = styled(StyledEmployerTableCell)`
  max-width: ${rem('72px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('72px')};
  `};
`;

const StyledEmployerTableCellPhones = styled(StyledEmployerTableCell)`
  max-width: ${rem('150px')};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('150px')};
  `};
`;

const StyledEmployerTableCellEmail = styled(StyledEmployerTableCell)`
  max-width: 98%;
  ${mediaqueries.greaterThan('desktop')`
     max-width: ${rem('230px')};
     width: ${rem('230px')};
  `};
`;

const StyledWrapperPhoto = styled(StyledEmployerTableCell)`
  display: inline;
  ${mediaqueries.greaterThan('tabletLandscape')`
     display: table-cell;
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('40px')};
  `};
`;

const StyledIcon = styled(Icon)`
  margin-top: ${rem('15px')};
  &:first-child {
    margin-right: ${rem('15px')};
    margin-top: ${rem('0px')};
  }
`;

export {
  StyledEmployerDirectory,
  StyledNamesWraper,
  StyledEmployerName,
  StyledEmployerLastName,
  StyledEmployerAlias,
  StyledPhoto,
  StyledEmployerTableCell,
  StyledEmployerTableCellProfile,
  StyledEmployerTableCellDepartment,
  StyledEmployerTableCellExtension,
  StyledEmployerTableCellPhones,
  StyledEmployerTableCellEmail,
  StyledHeaderDirectory,
  StyledHeaderItem,
  StyledTableWrapper,
  StyledWrapperPhoto,
  StyledIcon,
  IconButton
};
